import React from 'react'
import { Navbar } from '../../componenet/navbar/navbar'
import { Body } from '../../componenet/Body/body'
import Dashboard from '../../componenet/Dashboard/dashboard'


export const Home=()=>{
    return(
        <div>
            <Navbar/>
            <Body/>
            <Dashboard/>
        </div>
    )
}